var _g, _g2, _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReducedRiskOfErrors(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 230,
    viewBox: "0 0 240 230",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1527_4178)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M159.825 31C159.831 30.6675 159.834 30.3342 159.834 30L230 30C235.523 30 240 34.4772 240 40V220C240 225.523 235.523 230 230 230H10C4.47716 230 0 225.523 0 220V40C0 34.4772 4.47715 30 10 30L80.166 30C80.166 30.3342 80.1692 30.6675 80.1756 31H10C5.02944 31 1 35.0295 1 40V220C1 224.971 5.02944 229 10 229H230C234.971 229 239 224.971 239 220V40C239 35.0295 234.971 31 230 31H159.825Z",
    fill: "#31E5E5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 30,
    r: 39.5,
    stroke: "#31E5E5"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1527_4178)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120 58.8281C135.921 58.8281 148.828 45.9213 148.828 30C148.828 14.0787 135.921 1.17188 120 1.17188C104.079 1.17188 91.1719 14.0787 91.1719 30C91.1719 45.9213 104.079 58.8281 120 58.8281Z",
    fill: "#031F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120 58.7695C135.889 58.7695 148.77 45.889 148.77 30C148.77 14.111 135.889 1.23047 120 1.23047C104.111 1.23047 91.2305 14.111 91.2305 30C91.2305 45.889 104.111 58.7695 120 58.7695Z",
    stroke: "#31E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.855 17.6959V35.8248H104.193C104.188 35.722 104.183 35.6613 104.183 35.6007C104.183 29.7644 104.184 23.9284 104.187 18.0926C104.188 17.8455 104.22 17.5994 104.282 17.3603C104.615 16.0825 105.71 15.2832 107.114 15.2828C115.691 15.2822 124.268 15.2822 132.845 15.2828C132.948 15.2828 133.051 15.2791 133.154 15.2855C134.241 15.3502 135.052 15.8575 135.552 16.8264C135.673 17.1085 135.775 17.3989 135.855 17.6955M128.37 25.5533C128.37 20.9297 124.6 17.1348 120.011 17.1393C115.436 17.1437 111.676 20.9283 111.668 25.538C111.66 30.1603 115.424 33.9638 120.011 33.9686C124.597 33.9734 128.37 30.1764 128.37 25.5537",
    fill: "#4BAF71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.855 38.9805C135.775 39.2771 135.673 39.5675 135.551 39.8494C135.052 40.8192 134.24 41.3243 133.153 41.3917C133.143 41.3917 133.133 41.3917 133.122 41.3917C124.391 41.3921 115.66 41.3911 106.929 41.3885C106.315 41.3896 105.718 41.1822 105.237 40.8002C104.755 40.4183 104.418 39.8844 104.28 39.2858C104.167 38.7812 104.188 38.2468 104.145 37.6812H135.855V38.9805Z",
    fill: "#378C59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.348 44.7169C112.319 44.6924 112.288 44.6702 112.255 44.6505C111.811 44.4259 111.591 44.0177 111.689 43.5977C111.794 43.1446 112.16 42.8641 112.663 42.8617C113.476 42.8581 114.29 42.8608 115.103 42.8608H115.376V41.0195H124.651V42.8608H125.245C125.924 42.8608 126.604 42.8608 127.284 42.8608C127.871 42.8608 128.236 43.114 128.35 43.5975C128.453 44.0353 128.233 44.4142 127.727 44.6711C127.711 44.6792 127.703 44.7012 127.691 44.7169H112.348Z",
    fill: "#378C59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.514 25.5477C126.517 29.1499 123.577 32.1167 120.01 32.1123C116.456 32.1074 113.527 29.1474 113.524 25.5589C113.522 21.9567 116.461 18.9912 120.029 18.9956C123.583 18.9996 126.512 21.9585 126.515 25.5477M120.947 23.6695C120.947 23.0522 120.952 22.4344 120.946 21.817C120.939 21.2662 120.547 20.8584 120.03 20.8521C119.501 20.8458 119.095 21.2589 119.093 21.8259C119.088 23.0508 119.088 24.2755 119.093 25.5C119.094 26.0702 119.494 26.4833 120.023 26.4806C120.553 26.4779 120.941 26.0648 120.946 25.4911C120.951 24.884 120.947 24.2765 120.947 23.6695M120.006 30.2665C120.13 30.2668 120.252 30.2427 120.366 30.1955C120.481 30.1484 120.584 30.079 120.672 29.9916C120.759 29.9041 120.828 29.8002 120.875 29.6858C120.923 29.5715 120.947 29.449 120.946 29.3253C120.939 29.0813 120.839 28.8493 120.666 28.6772C120.492 28.5051 120.26 28.4062 120.016 28.4008C119.892 28.4012 119.77 28.426 119.656 28.4738C119.542 28.5216 119.439 28.5915 119.352 28.6794C119.265 28.7673 119.196 28.8715 119.15 28.986C119.103 29.1005 119.08 29.2231 119.081 29.3467C119.082 29.591 119.181 29.8249 119.354 29.9972C119.527 30.1695 119.762 30.2662 120.006 30.2662",
    fill: "#F9F9F9"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 90.5,
    y: 0.5,
    width: 59,
    height: 59,
    rx: 29.5,
    stroke: "#31E5E5"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1527_4178"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 240,
    height: 200,
    fill: "white",
    transform: "translate(0 30)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1527_4178"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 90,
    width: 60,
    height: 60,
    rx: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReducedRiskOfErrors);
export default __webpack_public_path__ + "static/media/ReducedRiskOfErrors.77b294517bfa464cb24454535e0d91ff.svg";
export { ForwardRef as ReactComponent };